import { FieldShell } from './FieldShell';
import { helperForField, labelForField } from '../helpers';
import type { FieldComponentProps } from './types';

export const CheckboxField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const helper = helperForField(field);
  return (
    <FieldShell field={field} error={error} hideLabel>
      <label className="flex items-start gap-2 cursor-pointer">
        <input
          id={field.title}
          type="checkbox"
          className="mt-1 h-4 w-4 rounded border-rgf-gray-300 text-rgf-primary-600 focus:ring-rgf-primary-500"
          checked={value === true}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="text-sm text-rgf-gray-700">
          {labelForField(field)}
          {field.rqd && <span className="text-red-500 ml-1">*</span>}
          {helper && !error && <span className="block text-xs text-rgf-gray-500 mt-0.5">{helper}</span>}
        </span>
      </label>
    </FieldShell>
  );
};
